import './hero-image.scss'

/**
 *  Component Definition
 *
 * @export
 * @class HeroImage
 * @implements {ng.IComponentOptions}
 */
export class HeroImage implements ng.IComponentOptions {

  /**
   * Controller used with Component
   *
   * @type {Function}
   */
  public controller: ng.IControllerConstructor = HeroImageController

  /**
   * Template used with Component
   *
   * @type {string}
   */
  public template: string = require('./hero-image.html').toString()

  /**
   * Object containing pairs Directive Bindings for Component
   *
   * @type {Object}
   */
  public bindings: { [binding: string]: string; } = {}
}

/**
 * HeroImage - Controller
 *
 * @export
 * @class HeroImageController
 */
export class HeroImageController {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', 'AngularServices', 'AppServices', '$element', '$animate']
  public isZoomed: boolean = false
  public zoomedBodyPart: string = "";
  public svgContainer: any
  public bodyPartsLoaded: number = 0
  public numBodyParts: number = 15
  public body
  public bodyPartUrls
  public bodyGroup
  public baseSVG
  public groups
  /**
   * @param {*} $log Angular Log Service
   * @param {*} AngularServices Angular Services Convenience Service
   * @param {*} AppServices App Services Convenience Service
   */
  constructor(public $log: any, public AngularServices: any, public AppServices: any, public $element: any, public $animate: any) {
    this.$log = $log.getInstance('HeroImage', false);
    this.$log.debug('constructor')
  }

  /**
     * life cycle hooks (road to ng2)
     * Called on each controller after all the controllers on an element have been constructed and had their bindings initialized (and before the pre & post linking functions for the directives on this element).
     */
  public $onInit(): void {
    this.$log.debug('onInit')
    // this.AppServices.HeroManager.init(this.$element.children(0), '.hero-image__container .svg')

  }

  /**
   * Called whenever one-way bindings are updated.
   * The changesObj is a hash whose keys are the names of the bound properties that have changed, and the values are an object of the form { currentValue, previousValue, isFirstChange() }.
   * Use this hook to trigger updates within a component such as cloning the bound value to prevent accidental mutation of the outer value.
   */
  public $onChanges(changesObj): void {
    this.$log.debug('onChanges', changesObj)

    // Clear the svg container to avoid repeated character on IE
    let heroContainerSVG = document.querySelector('.hero-image__container .svg')
    while (heroContainerSVG.firstChild) {
      heroContainerSVG.removeChild(heroContainerSVG.firstChild)
    }

    let hero: any = this.AppServices.ProgressManager.getHero()
    if (this.AppServices.ProgressManager.valueExists(hero)) {
      this.AppServices.HeroManager.init(this.$element.children(0), '.hero-image__container .svg', hero)
    } else {
      this.AppServices.HeroManager.init(this.$element.children(0), '.hero-image__container .svg', undefined)
    }


  }

  /**
   * Called on a controller when its containing scope is destroyed.
   * Use this hook for releasing external resources, watches and event handlers.
   */
  public $onDestroy(): void {
    this.$log.debug('onDestroy')
  }

  /**
   * Called after this controller's element and its children have been linked.
   * Similar to the post-link function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
   * Note that child elements that contain templateUrl directives will not have been compiled and linked since they are waiting for their template to load asynchronously and their own compilation and linking has been suspended until that occurs.
   * This hook can be considered analogous to the ngAfterViewInit and ngAfterContentInit hooks in Angular 2.
   * Since the compilation process is rather different in Angular 1 there is no direct mapping and care should be taken when upgrading.
   */
  public $postLink(): void {
    this.$log.debug('postLink')
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/hero-image/hero-image.ts
 **/